import IMAGES from "@/public/assets/img";

const corporateLoan = {
  seoData: {
    title:
      "Apply for Loan Against Property | Corporate LAP Financing by Credlix ",
    description:
      "vail corporate loan against property up to ₹25 Cr to fund business expansion, working capital, or capex needs. Secure financing using your property with flexible repayment.",
  },
  bannerHeading:
    '<span class="font-normal md:text-heading2">Loan Against Commercial</span> <span class="font-medium text-headingbig md:text-heading2 sm:text-textxl">Property Up to ₹25 Cr</span>',
  subheading: "Unlock Capital from Industrial & Commercial Assets",
  paraLoan:
    "Leverage warehouses, factories, commercial buildings, and leased assets to raise structured funding with high LTV and tenures up to 15 years.",
  btntext: "Talk to Our LAP Specialist",
  btntext2: "Structure My Corporate Mortgage",

  benefits: [
    {
      id: 1,
      icon: IMAGES?.dealerFinancing.RBILogo,
      text: "RBI-licensed NBFC platform ",
    },
    {
      id: 2,
      icon: IMAGES?.dealerFinancing.msme,
      text: "Trusted by 2,500+ enterprises & MSMEs ",
    },
    {
      id: 3,
      icon: IMAGES?.dealerFinancing.cities,
      text: "Active across 120+ cities ",
    },
    {
      id: 4,
      icon: IMAGES?.dealerFinancing.ERP,
      text: "Integrated with ERP & dealer networks ",
    },
  ],

  highValueLoan: {
    sectionTitle: "Why this matters",
    mainHeading: "High-value property sits idle while",
    highValueImage: [
      {
        id: 1,
        icon: IMAGES?.corporateLoan.expansion,
        description: "Expansion plans wait",
      },
      {
        id: 2,
        icon: IMAGES?.corporateLoan.capital,
        description: "Working capital tightens",
      },
      {
        id: 3,
        icon: IMAGES?.corporateLoan.equity,
        description: "Equity dilution becomes tempting",
      },
      {
        id: 4,
        icon: IMAGES?.corporateLoan.blanceSheet,
        description: "Balance sheet leverage is underutilized",
      },
    ],
  },

  lapSoulations: {
    sectionTitle: "Credlix LAP Solution",
    mainHeading: "Structured Corporate Mortgage Lending",
    image: IMAGES?.corporateLoan.lapHome,
    cases: [
      {
        id: 1,
        text: "Loan amount up to <b>₹25 Cr</b>",
      },
      {
        id: 2,
        text: "<b>High LTV</b> on industrial property",
      },
      {
        id: 3,
        text: "Tenure up to <b>15 years</b>​",
      },
    ],
  },

  acceptedCollaterals: {
    sectionTitle: "Accepted Collaterals",
    benefits: [
      {
        id: 1,
        icon: IMAGES?.corporateLoan.commercial,
        text: "Commercial office buildings",
      },
      {
        id: 2,
        icon: IMAGES?.corporateLoan.industrial,
        text: "Industrial sheds",
      },
      {
        id: 3,
        icon: IMAGES?.corporateLoan.warehouses,
        text: "Warehouses",
      },
      {
        id: 4,
        icon: IMAGES?.corporateLoan.revenue,
        text: "Revenue-generating leases",
      },
      {
        id: 5,
        icon: IMAGES?.corporateLoan.manufacturing,
        text: "Manufacturing units",
      },
    ],
  },

  HowItWorks: {
    heading: '<span class="text-baseBlack">Why Credlix </span><span class="text-yellow-400">Over Banks?</span>',
    whySection: [
      {
        id: "1",
        image: IMAGES?.corporateLoan.approval,
        text: "Faster than traditional mortgage approval​",
      },
      {
        id: "2",
        image: IMAGES?.corporateLoan.builts,
        text: "Built for corporates & promoters​",
      },
      {
        id: "3",
        image: IMAGES?.corporateLoan.structured,
        text: "Structured underwriting",
      },
      {
        id: "4",
        image: IMAGES?.corporateLoan.rbi,
        text: "RBI licensed NBFC​",
      },
      {
        id: "5",
        image: IMAGES?.corporateLoan.panIndia,
        text: "Pan-India coverage​",
      },
    ],
  },

  industryCases: {
    sectionTitle: "Industry Use Cases",
    mainHeading: "Financing for Growth and Stability",
    image: IMAGES.corporateLoan.financing,
    cases: [
      {
        id: 1,
        text: "Working capital bridge",
      },
      {
        id: 2,
        text: "Machinery purchase",
      },
      {
        id: 3,
        text: "Expansion funding​",
      },
      {
        id: 4,
        text: "Debt consolidation",
      },
      {
        id: 5,
        text: "Balance transfer​",
      },
    ],
  },

  FaqHead: "Frequently Asked Questions",
  Faq: [
    {
      id: 0,
      question: "What is a Corporate Loan Against Property (LAP) and how does it help businesses grow?",
      answers:
        "A Corporate Loan Against Property is a secured lending facility where a business mortgages its industrial or commercial real estate to raise capital for expansion, machinery purchase, or working capital needs. It allows promoters to unlock the latent value of their fixed assets without diluting equity. At Credlix, we offer structured underwriting that considers the business’s cash flow and growth potential, providing loan amounts up to ₹25 Crore. ",
    },
    {
      id: 1,
      question: "How is a standard Loan Against Property (LAP) different from Lease Rental Discounting (LRD)? ",
      answers: "It is important to note that LAP and LRD are distinct financial products with different eligibility criteria. A Loan Against Property is based on the current market value of your property and your business’s overall repayment capacity. Lease Rental Discounting, on the other hand, is a specialized variant underwritten primarily on the strength of a fixed rental income stream from a corporate tenant. While Credlix provides both under our corporate mortgage suite, the choice depends on whether the asset is owner-occupied (LAP) or leased to a third party (LRD).",
    },
    {
      id: 2,
      question: "What types of industrial and commercial properties are eligible for Credlix LAP?",
      answers:
        "Credlix accepts a wide variety of income-generating and owner-occupied assets across India, including industrial sheds, manufacturing units, warehouses, commercial office buildings, retail shops, and even partially vacant properties. The property must be litigation-free and have a clear title, though we specialize in handling the complex documentation often associated with industrial assets that traditional banks may reject. ",
    },
    {
      id: 3,
      question: "Can company promoters or directors apply for funding against personally owned property?",
      answers: "Yes. Credlix facilitates promoter funding where personal or company-owned assets serve as collateral for business-related loans. Both the entity and the promoters can be applicants, allowing for a higher eligibility based on the combined income profile. This is an ideal solution for manufacturers looking to raise high-value capital for plant expansion or debt consolidation. ",
    },
    {
      id: 4,
      question: "How does the speed of Credlix Corporate LAP compare to traditional bank mortgage processes?",
      answers: "Traditional bank mortgage approvals are notoriously slow, often taking 30 to 60 days due to bureaucratic valuation and legal verification stages. Credlix’s digital-first underwriting and specialized understanding of industrial assets allow us to issue a sanction letter within 5 to 10 working days. Final disbursement typically occurs in 15 to 20 days, ensuring that growth opportunities are not lost to financing delays. ",
    },
    {
      id: 5,
      question: "What are the typical loan amounts, tenures, and LTV ratios offered by Credlix?",
      answers: "Provide funding up to ₹25 Crore with a high Loan-to-Value (LTV) ratio, often reaching up to 70% to 75% for industrial assets. The repayment tenures are flexible, extending up to 15 years, which helps in reducing the monthly EMI burden and maintaining healthy debt service coverage ratios (DSCR).",
    },
    {
      id: 6,
      question: "What are the primary documentation requirements for a corporate mortgage application?",
      answers: "To expedite the process, applicants should provide business registration proof (GST/Udyam), the last three years of audited financials (Balance Sheet and P&L), 12 months of bank statements, and the complete chain of property documents. For cases involving LRD, a valid lease agreement and tenant credentials are also required.",
    },
    {
      id: 7,
      question: "Is there a minimum credit score required for Credlix Corporate LAP?",
      answers: "While we assess each case holistically, a CIBIL score of 700 or above is generally preferred for the fastest approval. However, Credlix’s focus on structured underwriting means we can often provide solutions for businesses with strong cash flows or high-value collateral even if their credit profile is currently being built.",
    }
  ],
};
export default corporateLoan;
